import React from 'react';
import PropTypes from 'prop-types';

import StyledDropdownHeader from './StyledDropdownHeader';

const DropdownHeader = ({children}) => {

	return <StyledDropdownHeader>{children}</StyledDropdownHeader>;
};

DropdownHeader.propTypes = {};

export default DropdownHeader;
